<div class="selector-dropdown">
  <div class="p-inputgroup">
    <input [attr.data-testid]="'selector-input' + (dataTestId ? '-' + dataTestId : '')" type="text" class="input-selector" pInputText placeholder="{{placeholder}}" readonly [disabled]="disabled"
      [(ngModel)]="selectedValue" (click)="show = !show" [attr.id]="formControlName"/>
    <button [hidden]="selectedValue === undefined || showClear == false || disabled" class="p-button-text p-button-secondary button-selector" pButton icon="pi pi-times" (click)="onClearClick($event)"></button>
    <button [hidden]="disabled" class="p-button-text p-button-secondary button-selector" pButton icon="pi pi-chevron-down" (click)="show = !show"></button>
  </div>

  @if (show) {
    <div class="container-selector">
      <div class="panel-selector">
        <div class="filter-selector">
          <span class="p-input-icon-right" >
            <i class="pi pi-search"></i>
            <input [attr.data-testid]="'selector-filter-input' + (dataTestId ? '-' + dataTestId : '')" type="text" pInputText [(ngModel)]="filterData" (ngModelChange)="onChangeFilter($event)" (keydown.enter)="onEnter($event)"/>
          </span>
        </div>
        <p-listbox [filter]="false" [options]="options" optionLabel="{{optionLabel}}" [listStyle]="{'max-height':'250px'}"
          [checkbox]="isMultiselect" [multiple]="isMultiselect" [(ngModel)]="selectedItem"
          (ngModelChange)="onSelectClick($event)">
          <ng-template let-option pTemplate="item" let-i="index">
            <div class="listbox-item" [attr.data-testid]="'listbox-item-' + i">
              {{ optionLabel ? option[optionLabel] : option }}
            </div>
          </ng-template>
        </p-listbox>
        @if (hasRecords()) {
          <div class="p-inputgroup" >
            <button data-testid="selector-previous-page-btn" type="button" pButton class="p-button-text p-button-secondary previous-page" icon="pi pi-angle-left" (click)="onPreviousPage($event)" [disabled]="activePage === 0"></button>
            <input data-testid="selector-pagination-label" type="text" class="pagination-selector" pInputText placeholder="{{ activePage + 1}} {{ 'PAGINATION.OF' | translate }} {{totalPages}}" readonly>
            <button data-testid="selector-next-page-btn" type="button" pButton class="p-button-text p-button-secondary next-page" icon="pi pi-angle-right" (click)="onNextPage($event)" [disabled]="activePage >= totalPages - 1"></button>
          </div>
        }
        @if (!hasRecords()) {
          <div class="flex flex-col items-center" >
            {{ 'ERRORS.40401' | translate }}
          </div>
        }
      </div>
    </div>
  }
</div>
